import { Box, Card } from "@mui/material";
import {
  DataGrid,
  GridColumnVisibilityModel,
  GridColumns,
  GridRowIdGetter,
  GridRowParams,
  GridToolbar,
} from "@mui/x-data-grid";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addGridSetting,
  useAddAppGridSettingMutation,
} from "../../redux/reducer/features/App/AppGridSlice";
import { AppGridId, GridIdsToSave } from "../../models/app/AppGridModels";
import { AppState } from "../../redux/reducer/rootReducer";
interface AppGridProps {
  columns: GridColumns<any>;
  isLoading: boolean;
  data: any[];
  height?: any;
  onSelect?: any;
  selectedRows?: any;
  checkBox?: boolean;
  getRowId?: GridRowIdGetter<any>;
  isRowSelectable?: ((params: GridRowParams<any>) => boolean) | undefined;
  gridId?: AppGridId | undefined;
}
const AppGrid: React.FunctionComponent<AppGridProps> = (props) => {
  const { userId } = useSelector((state: AppState) => state.authReducer);
  const dispatch = useDispatch();
  const [saveSettingMutation, settingMutationResult] =
    useAddAppGridSettingMutation();
  const handleSetVisibilityModel = (model: GridColumnVisibilityModel) => {
    if (props.gridId !== undefined) {
      dispatch(
        addGridSetting({
          setting: { gridId: props.gridId, columnVisibilityModel: model },
        })
      );
      if (GridIdsToSave.includes(props.gridId)) {
        var data = JSON.stringify(model);
        saveSettingMutation({
          data: { userId: userId ?? "", gridId: props.gridId, setting: data },
        });
      }
    }
  };
  return (
    <>
      <Card>
        <Box sx={{ height: props.height ?? 590, width: "100%" }}>
          <DataGrid
            getRowId={props.getRowId}
            rows={props.data}
            columns={props.columns}
            rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
            checkboxSelection={props.checkBox === true ? false : true}
            disableSelectionOnClick
            loading={props.isLoading}
            selectionModel={props.selectedRows}
            onSelectionModelChange={(newSelection: any, detail: any) => {
              props.onSelect && props.onSelect(newSelection);
            }}
            components={{ Toolbar: GridToolbar }}
            componentsProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            isRowSelectable={props.isRowSelectable}
            onColumnVisibilityModelChange={handleSetVisibilityModel}
          />
        </Box>
      </Card>
    </>
  );
};

export default AppGrid;
